import { InputText } from 'primereact/inputtext';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { rightArrowRed, searchIcon, rightArrowDisabled } from 'assets/icons';
import './filterElements.scss';
import usePageInfo from 'utility/hooks/usePageInfo';
import { useAnalyticsContext } from 'providers/AnalyticProvider';
import { SEARCH_PERFORMED } from 'constants/analyticEvents';

export function ClearButton({ onClick, searchValue }) {
  const [hoverAction, setHoverAction] = useState();

  return (
    searchValue && (
      <>
        <div
          data-testid="reset-button"
          role="presentation"
          className="filter-panel-icon d-flex align-items-center search-clear-button"
          onClick={() => onClick()}
          onMouseEnter={() => {
            setHoverAction('clear');
          }}
          onMouseLeave={() => {
            setHoverAction(undefined);
          }}
        >
          <p className={hoverAction === 'clear' ? 'hovered' : ''}>Clear</p>
        </div>
        <div className="clear-divider" />
      </>
    )
  );
}

ClearButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  searchValue: PropTypes.string.isRequired,
};

function SearchBar({
  onChange,
  searchValue,
  placeholderText,
  onSubmitSearch,
  className,
  sectionName,
  isGlobalFilter,
  customInputClass,
}) {
  const analytics = useAnalyticsContext();
  const { moduleName, pageName } = usePageInfo();

  const handleSubmitSearch = (value) => {
    onSubmitSearch(value);
    analytics?.sendGAEvent(SEARCH_PERFORMED, {
      search_term: value,
      section_name: sectionName,
      module_name: moduleName,
      page_name: pageName,
    });
  };
  return (
    <div className={className}>
      <span className={`${customInputClass} search-box w-100`}>
        <img src={searchIcon} alt="search" className="search-icon" />
        <InputText
          value={searchValue}
          onChange={(changeEvent) => {
            if (changeEvent.target && changeEvent.target.value.length <= 200) {
              onChange(changeEvent.target.value);
            }
            if (!changeEvent.target.value) {
              handleSubmitSearch('');
            }
          }}
          onKeyUp={(clickEvent) => {
            if (clickEvent.key === 'Enter') {
              handleSubmitSearch(searchValue);
            }
          }}
          id="search-input"
          data-testid="search-input-box"
          className="search-input"
          placeholder={placeholderText}
        />
        <ClearButton
          onClick={() => {
            if (isGlobalFilter) {
              onSubmitSearch('');
            } else {
              onChange('');
            }
          }}
          searchValue={searchValue}
        />
        <img
          src={searchValue ? rightArrowRed : rightArrowDisabled}
          alt="search"
          onClick={() => handleSubmitSearch(searchValue)}
          className="search-submit cursor-pointer"
          data-testid="search-btn"
        />
      </span>
    </div>
  );
}
SearchBar.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSubmitSearch: PropTypes.func.isRequired,
  searchValue: PropTypes.string,
  placeholderText: PropTypes.string,
  sectionName: PropTypes.string,
  isGlobalFilter: PropTypes.bool,
  customInputClass: PropTypes.string,
};
SearchBar.defaultProps = {
  className: '',
  searchValue: '',
  placeholderText: '',
  customInputClass: '',
  sectionName: 'default',
  isGlobalFilter: false,
};
export default SearchBar;
